import { Component, OnInit } from '@angular/core';
import { NodeService } from '../../services/node-service/node-service.service';

@Component({
  selector: 'app-edit-rootcategory',
  templateUrl: './edit-rootcategory.component.html',
  standalone: false,
})
export class EditRootcategoryComponent implements OnInit {
  title: string = 'Editar';

  constructor(private nodeService: NodeService) {}

  ngOnInit(): void {
    const category = this.nodeService.getCategoryToEdit();
    this.title = `Editar ${category?.nombre}`;
  }
}
